import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { SessionService } from './session.service';


@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  endPointSunat = "https://sunat-sujetos-sin-capacidad-operativa.onrender.com";
  constructor(
    private http: HttpClient,
    private sessionService: SessionService
  ) {}

  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'client-id': 'apliclientesksks',
      'client-hash': 'apliclientesksks',
      Auth: this.sessionService.token,
    }),
  };

  
  // listCompanies(body){
  //   return this.http.post(`${environment.baseUrlAPI}/admin/getCompaniesAll`, body, this.httpOptions);
  // }

  listResumProvidersCompany(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/listResumProvidersCompany`, body, this.httpOptions);
  }

  listCompanySecoundCategoriesCBN(){
    return this.http.post(`${environment.baseUrlAPI}/admin/listCompanySecoundCategoriesCBN`, {},  this.httpOptions);
  }
  
  peruvianCompaniesExportXlsx(){
    return this.http.post(`${environment.baseUrlAPI}/companies/peruvian/exportXlsx`, {},  this.httpOptions);
  }
  
  peruvianCompaniesUpdate(body){
    return this.http.post(`${environment.baseUrlAPI}/companies/peruvian/update`, body,  this.httpOptions);
  }

  /**
   * metodo para traer información del perfil empresa
   * @param body { idCompany }
   * @returns 
   */
  getCompanyProfileGeneralData(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/panel/summary`, body,  this.httpOptionsNew)
  }
  /**
   *  metodo para traer información del formulario completo de empresa
   * @param body  { idCompany }
   * @returns 
   */
  // getCompanyTabSummaryData(body){
  //   return this.http.post(`${environment.baseUrlAPI}/admin/getCompanyTabSummaryData`, body,  this.httpOptions)
  // }
  /**
   *  metodo para traer información de los ejecutivos de empresa
   * @param body  { idCompany }
   * @returns 
   */
   getCompanyTabContactData(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/getCompanyTabContactData`, body,  this.httpOptions)
  }
  /**
   *  metodo para traer información del formulario completo de empresa
   * @param body  { idCompany }
   * @returns 
   */
  getCompanyTabPlanData(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/panel/plans`, body,  this.httpOptionsNew)
  }
  /**
   *  metodo para crear una nueva suscripcion a una empresa
   * @param body  { idCompany, idPlan, additionalUsers, startDate, dueDate, paymentDate, dateOfNotification, renovation, planSelected }
   * @returns 
   */
  createCompanyPlan(body){
    return this.http.put(`${environment.baseUrlAPINEW}/company/panel/plans/save`, body,  this.httpOptionsNew)
  }
  /**
   *  metodo para eliminar una suscripcion a una empresa
   * @param body  { idCompany, startDate }
   * @returns 
   */
   deleteCompanyPlan(body){
    const httpOptionsTemp = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.sessionService.token}`
      }),
      body: body
    };
    return this.http.delete(`${environment.baseUrlAPINEW}/admin/deleteCompanyPlan`, httpOptionsTemp);
  }
  /**
   *  metodo para obtener usuarios de una empresa
   * @param body  { idCompany }
   * @returns 
   */
  getUsersCompany(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/panel/users`, body,  this.httpOptionsNew)
  }
  /**
   *  metodo para asociar usuarios a una empresa
   * @param body  { idCompany, idUser }
   * @returns 
   */
  addUserCompany(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/panel/users/add`, body,  this.httpOptionsNew)
  }
  /**
   *  metodo para eliminar usuarios de una empresa
   * @param body  { idCompany, idUser }
   * @returns 
   */
  deleteUserCompany(body){
    const httpOptionsTemp = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.sessionService.token}`
      }),
      body: body
    };
    return this.http.delete(`${environment.baseUrlAPINEW}/company/panel/users/delete`, httpOptionsTemp);
  }

  /**
   *  metodo para obtener usuarios de una empresa
   * @param body  { idCompany, query }
   * @returns 
   */
  getUsersQueryNotCompany(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/panel/users/search`, body,  this.httpOptionsNew)
  }
/**
   *  metodo para obtener estado de una empresa
   * @param body  { idCompany }
   * @returns 
   */
  getStatusCompany(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/panel/statusForms`, body,  this.httpOptionsNew)
  }

  //invitacion masiva a los proveedores
  listClients(){
    return this.http.post(`${environment.baseUrlAPI}/admin/listClients`, {},  this.httpOptions)
  }

  listCompaniesNotSupplier(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/listCompaniesNotSupplier`, body,  this.httpOptions)
  }

  inviteSupplier(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/inviteSupplier`, body,  this.httpOptions)
  }

  companiesPremium(){
    return this.http.post(`${environment.baseUrlAPI}/admin/companiesPremium`, {},  this.httpOptions)
  }

  evaluationsCompanyPremium(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/evaluationsCompanyPremium`, body,  this.httpOptions)
  }

  requestEvaluationsCompanyPremium(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/requestEvaluationsCompanyPremium`, body,  this.httpOptions)
  }

  shippingAwardedCompanyPremium(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/shippingAwardedCompanyPremium`, body,  this.httpOptions)
  }

  shippingAwardedTechnicalCompanyPremium(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/shippingAwardedTechnicalCompanyPremium`, body,  this.httpOptions)
  }

  deleteCompany(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/deleteCompany`, body,  this.httpOptions)
  }

  exportXlsxExecutivesCompanyAll(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/exportXlsxExecutivesCompanyAll`, body,  this.httpOptions)
  }

  //Campos para plantillas docx
  createTag(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/createTag`, body,  this.httpOptions)
  }
  
  updateTag(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/updateTag`, body,  this.httpOptions)
  }

  panelTag(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/panelTag`, body,  this.httpOptions)
  }

  deleteTag(body){
    const httpOptionsTemp = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'client-id':'apliclientesksks',
        'client-hash':'apliclientesksks',
        'Auth': this.sessionService.token
      }),
      body: body
    };
    return this.http.delete(`${environment.baseUrlAPI}/admin/deleteTag`, httpOptionsTemp);
  }
  
  //Tipos de plantillas docx
  createTemplateDocxFieldsModule(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/createTemplateDocxFieldsModule`, body,  this.httpOptions)
  }
  
  updateTemplateDocxFieldsModule(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/updateTemplateDocxFieldsModule`, body,  this.httpOptions)
  }

  panelTemplateDocxFieldsModule(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/panelTemplateDocxFieldsModule`, body,  this.httpOptions)
  }

  deleteTemplateDocxFieldsModule(body){
    const httpOptionsTemp = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'client-id':'apliclientesksks',
        'client-hash':'apliclientesksks',
        'Auth': this.sessionService.token
      }),
      body: body
    };
    return this.http.delete(`${environment.baseUrlAPI}/admin/deleteTemplateDocxFieldsModule`, httpOptionsTemp);
  }


//servicio
  listService(){
    return this.http.get(`${environment.baseUrlAPI}/admin/servicesAndSubservices`, this.httpOptions)
  }

  deleteService(body){
    const httpOptionsTemp = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'client-id':'apliclientesksks',
        'client-hash':'apliclientesksks',
        'Auth': this.sessionService.token
      }),
      body: body
    };
    return this.http.delete(`${environment.baseUrlAPI}/admin/service`, httpOptionsTemp);
  }

  createService(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/service`, body, this.httpOptions);
  }

  editService(body){
    return this.http.put(`${environment.baseUrlAPI}/admin/service`,body, this.httpOptions);
  }

  sortService(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/sortService`, body, this.httpOptions);
  }

  //subservicio

  listSubService(){
    return this.http.get(`${environment.baseUrlAPI}/admin/servicesAndSubservices`, this.httpOptions)
  }

  deleteSubService(body){
    const httpOptionsTemp = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'client-id':'apliclientesksks',
        'client-hash':'apliclientesksks',
        'Auth': this.sessionService.token
      }),
      body: body
    };
    return this.http.delete(`${environment.baseUrlAPI}/admin/subservice`, httpOptionsTemp);
  }

  createSubService(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/subservice`, body, this.httpOptions);
  }

  editSubService(body){
    return this.http.put(`${environment.baseUrlAPI}/admin/subservice`,body, this.httpOptions);
  }

  sortSubService(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/sortSubService`, body, this.httpOptions);
  }

  //servicio y subservicio usuario
  listServicesAndSubservicesUser(){
    return this.http.get(`${environment.baseUrlAPI}/admin/servicesAndSubservicesUser`, this.httpOptions)
  }

  deleteServiceUser(body){
    const httpOptionsTemp = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'client-id':'apliclientesksks',
        'client-hash':'apliclientesksks',
        'Auth': this.sessionService.token
      }),
      body: body
    };
    return this.http.delete(`${environment.baseUrlAPI}/admin/serviceUser`, httpOptionsTemp);
  }

  createServiceUser(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/serviceUser`, body, this.httpOptions);
  }

  editServiceUser(body){
    return this.http.put(`${environment.baseUrlAPI}/admin/serviceUser`,body, this.httpOptions);
  }

  sortServiceUser(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/sortServiceUser`, body, this.httpOptions);
  }

  //subservicio usuario


  deleteSubServiceUser(body){
    const httpOptionsTemp = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'client-id':'apliclientesksks',
        'client-hash':'apliclientesksks',
        'Auth': this.sessionService.token
      }),
      body: body
    };
    return this.http.delete(`${environment.baseUrlAPI}/admin/subserviceUser`, httpOptionsTemp);
  }

  createSubServiceUser(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/subserviceUser`, body, this.httpOptions);
  }

  editSubServiceUser(body){
    return this.http.put(`${environment.baseUrlAPI}/admin/subserviceUser`,body, this.httpOptions);
  }

  sortSubServiceUser(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/sortSubServiceUser`, body, this.httpOptions);
  }




  //Como funciona

  panelVideo(){
    return this.http.get(`${environment.baseUrlAPI}/admin/panelVideos`, this.httpOptions);
  }

  panelVideosUser(){
    return this.http.get(`${environment.baseUrlAPI}/admin/panelVideosUser`, this.httpOptions);
  }

  sortVideos(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/sortVideos`,body, this.httpOptions);
  }

  sortVideosUser(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/sortVideosUser`,body, this.httpOptions);
  }

  createVideo(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/createVideo`,body, this.httpOptions);
  }

  createVideoUser(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/createVideoUser`,body, this.httpOptions);
  }

  updateVideo(body){
    return this.http.put(`${environment.baseUrlAPI}/admin/updateVideo`,body, this.httpOptions);
  }

  updateVideoUser(body){
    return this.http.put(`${environment.baseUrlAPI}/admin/updateVideoUser`,body, this.httpOptions);
  }
  
  deleteVideo(body){
    const httpOptionsTemp = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'client-id':'apliclientesksks',
        'client-hash':'apliclientesksks',
        'Auth': this.sessionService.token
      }),
      body: body
    };
    return this.http.delete(`${environment.baseUrlAPI}/admin/deleteVideo`,httpOptionsTemp);
  }

  deleteVideoUser(body){
    const httpOptionsTemp = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'client-id':'apliclientesksks',
        'client-hash':'apliclientesksks',
        'Auth': this.sessionService.token
      }),
      body: body
    };
    return this.http.delete(`${environment.baseUrlAPI}/admin/deleteVideoUser`,httpOptionsTemp);
  }

  detailVideo(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/detailVideo`,body, this.httpOptions);
  }

  detailVideoUser(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/detailVideoUser`,body, this.httpOptions);
  }

  //Actualizador

  getListUpdates(){
    return this.http.get(`${environment.baseUrlAPI}/admin/update`, this.httpOptions);
  }

  createUpdate(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/update`,body, this.httpOptions);
  }

  deleteUpdate(body){
    const httpOptionsTemp = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'client-id':'apliclientesksks',
        'client-hash':'apliclientesksks',
        'Auth': this.sessionService.token
      }),
      body: body
    };
    return this.http.delete(`${environment.baseUrlAPI}/admin/update`,httpOptionsTemp);
  }

  getPublication(){
    return this.http.get(`${environment.baseUrlAPI}/admin/publication`, this.httpOptions);
  }

  createPublication(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/publication`,body , this.httpOptions);
  }

  detailPublication(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/detailpublication`,body ,this.httpOptions);
  }

  updatePublication(body){
    return this.http.put(`${environment.baseUrlAPI}/admin/update`,body ,this.httpOptions);
  }

  commentsList(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/videoUser/comments`,body ,this.httpOptions);
  }

  commentsCreate(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/videoUser/createComment`,body ,this.httpOptions);
  }

  commentsUpdate(body){
    return this.http.put(`${environment.baseUrlAPI}/admin/videoUser/updateComment`,body ,this.httpOptions);
  } 

  commentsDelete(body){
    const httpOptionsTemp = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'client-id':'apliclientesksks',
        'client-hash':'apliclientesksks',
        'Auth': this.sessionService.token
      }),
      body: body
    };
    return this.http.delete(`${environment.baseUrlAPI}/admin/videoUser/deleteComment`,httpOptionsTemp);
  } 

  responsesList(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/videoUser/responsesComment`,body ,this.httpOptions);
  }

  //

  commentsCompanyList(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/video/comments`,body ,this.httpOptions);
  }

  commentsCompanyCreate(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/video/createComment`,body ,this.httpOptions);
  }

  commentsCompanyUpdate(body){
    return this.http.put(`${environment.baseUrlAPI}/admin/video/updateComment`,body ,this.httpOptions);
  } 

  commentsCompanyDelete(body){
    const httpOptionsTemp = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'client-id':'apliclientesksks',
        'client-hash':'apliclientesksks',
        'Auth': this.sessionService.token
      }),
      body: body
    };
    return this.http.delete(`${environment.baseUrlAPI}/admin/video/deleteComment`,httpOptionsTemp);
  } 

  responsesCompanyList(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/video/responsesComment`,body ,this.httpOptions);
  }

  depriveVideo(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/depriveVideo`,body ,this.httpOptions);
  }

  depriveVideoUser(body){
    return this.http.post(`${environment.baseUrlAPI}/admin/depriveVideoUser`,body ,this.httpOptions);
  }

  //API DL3G0

  getSincapoperativa(){
    return this.http.get(`${environment.baseUrlAPINEW}/company/non-operating/sscoSunat`, this.httpOptionsNew);
  }

  getSincapoperativaXlsx(){
    return this.http.get(`${this.endPointSunat}/api/sincapoperativa-excel`,{
      responseType: 'blob'
    });
  }

  getAgentesRetencion(){
    return this.http.get(`${this.endPointSunat}/api/agentes-json`,{});
  }

  getAgentesRetencionXlsx(){
    return this.http.get(`${this.endPointSunat}/api/agentes-excel`,{
      responseType: 'blob'
    });
  }

  getBuenContribuyente(){
    return this.http.get(`${this.endPointSunat}/api/buen-contribuyente-json`,{});
  }

  getBuenContribuyenteXlsx(){
    return this.http.get(`${this.endPointSunat}/api/buen-contribuyente-excel`,{
      responseType: 'blob'
    });
  }

  //

  private httpOptionsNew = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.sessionService.token}`
    }),
  };

  companyNonOperatingCreate(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/non-operating/create`,body, this.httpOptionsNew);
  }

  companyNonOperatingUpdate(body){
    return this.http.put(`${environment.baseUrlAPINEW}/company/non-operating/update`,body, this.httpOptionsNew);
  }

  companyNonOperatingDelete(body){
    const httpOptionsTemp = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.sessionService.token}`
      }),
      body: body
    };
    return this.http.delete(`${environment.baseUrlAPINEW}/company/non-operating/delete`,httpOptionsTemp);
  }

  companyNonOperatingDeleteMultiple(body){
    const httpOptionsTemp = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.sessionService.token}`
      }),
      body: body
    };
    return this.http.delete(`${environment.baseUrlAPINEW}/company/non-operating/deleteMultiple`,httpOptionsTemp);
  }

  companyNonOperatingSaveMultiple(body){
    return this.http.put(`${environment.baseUrlAPINEW}/company/non-operating/saveMultiple`,body, this.httpOptionsNew);
  }

   companyNonOperatingPagination(body){
    return this.http.post(`${environment.baseUrlAPINEW}/company/non-operating/pagination`,body, this.httpOptionsNew);
  }

  getCompanyPreferences(body: { idCompany: string }){
    return this.http.post(`${environment.baseUrlAPIPlatform}/company/panel/summary/preference`, body, this.httpOptionsNew);
  }

  saveCompanyCurrencies(body: { idCompany: string, currencies: string[] }){
    return this.http.post(`${environment.baseUrlAPIPlatform}/company/panel/summary/preference/saveCurrencies`, body, this.httpOptionsNew);
  }
}
